import ongroundDarkBackgroundLogo from "./assets/branding/onground-powered-by-dark-bg.png";
import ongroundLightBackgroundLogo from "./assets/branding/onground-powered-by-light-bg.png";

export const ONGROUND_LOGO_SURFACE = Object.freeze({
  LIGHT: "light",
  DARK: "dark",
});

const ONGROUND_LOGO_BY_SURFACE = Object.freeze({
  [ONGROUND_LOGO_SURFACE.LIGHT]: ongroundLightBackgroundLogo,
  [ONGROUND_LOGO_SURFACE.DARK]: ongroundDarkBackgroundLogo,
});

export const resolveOngroundLogoForSurface = (surface) =>
  ONGROUND_LOGO_BY_SURFACE[surface] ||
  ONGROUND_LOGO_BY_SURFACE[ONGROUND_LOGO_SURFACE.LIGHT];